import { useMemo, useCallback, useState, useEffect } from "react";
import { Text, Stack, VStack, CircularProgress } from "@chakra-ui/react";

import Paginator from "components/Paginator/Paginator";
import HistoryItem from "components/AffiliateItems/HistoryItem";

import { useHistory } from "react-router-dom";
import { useGetAffiliatesQuery } from "services/walletApi";
import { isEmpty } from "lodash";
import { toQueryString } from "util/utils";

import Emitter from "libs/Emitter";

export default function InviteHistoryAffiliatePanel(props) {
  const { filters } = props;
  const history = useHistory();

  const [state, _setState] = useState({
    page: 1,
    limit: 10,
    // ...filters,
  });

  const queries = useMemo(
    () =>
      toQueryString({
        ...state,
        ...filters,
      }),
    [state, filters]
  );

  const setState = useCallback(
    (newState) => _setState(() => ({ ...state, ...newState })),
    [state]
  );

  const { data, isLoading } = useGetAffiliatesQuery(queries);

  // useEffect(() => {
  //   getLeaderboard();
  // }, [getLeaderboard]);

  const referrals = useMemo(() => data?.referrals, [data]);
  const totalCount = useMemo(() => data?.totalCount, [data]);
  console.log("INVITE HISTORY", referrals);

  // console.log("FILTERS", filters);

  const setFilter = useCallback(
    (filter) => {
      setState({ ...filter });
    },
    [setState]
  );

  useEffect(() => {
    Emitter.on("PARTNERS_VIEW_DATE_FILTER", setFilter);

    return () => {
      Emitter.off("PARTNERS_VIEW_DATE_FILTER", setFilter);
    };
  }, [setFilter]);

  return (
    <Stack>
      {/* {Array(10)
        .fill(0)
        .map((_, i) => (
          <HistoryItem
            key={`invite-history-panel-${i}`}
            to={`/dashboard/account/partners/invites/${i + 1}`}
          />
        ))} */}

      <VStack>
        {isLoading && (
          <CircularProgress
            disabled
            isIndeterminate
            color="#a7a7a7"
            size="32px"
          />
        )}

        {!isLoading && isEmpty(referrals) && <Text>History not found</Text>}
      </VStack>

      {referrals?.map((ref, i) => (
        <HistoryItem
          key={`invite-history-${i}`}
          // to={`/dashboard/account/partners/invites/${ref?._id}`}
          name={`${ref?.referredUser?.firstName} ${ref?.referredUser?.lastName}`}
          email={`@${ref?.referredUser?.username} (Level ${ref?.referredUser?.kycLevel})`}
          createdAt={ref?.registeredOn}
          onClick={() =>
            history.push(
              `/dashboard/account/partners/invites/${ref?.referredUser?._id}`,
              ref
            )
          }
        />
      ))}

      {totalCount && (
        <Paginator
          page={state?.page}
          limit={state?.limit}
          totalCount={totalCount}
          onNextPage={(next) => setState({ page: next })}
        />
      )}
    </Stack>
  );
}
